import {Component, inject, input, output, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SessionService} from "../../../services/session.service";

@Component({
  selector: 'comments-section',
  templateUrl: './comments-section.component.html',
  standalone: false
})
export class CommentsSectionComponent {
  data = input.required<any[]>();
  loading = input<boolean>(false);
  create = output<string>();
  edit = output<{ commentId: string, commentContent: string }>();
  delete = output<string>();

  currentUser: any;
  pendingCommentContent: string = '';
  editCommentId: string | null = null;
  editCommentContent: string = '';
  commentToDeleteId: string | null = null;

  private readonly sessionService = inject(SessionService);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.sessionService.currentUser
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => this.currentUser = res.user);
  }

  canEditComment(item: any) {
    return this.currentUser.user_id == item.cp_user_id;
  }

  getFirstAndLastNames(fullName: string) {
    return {
      first_name: fullName.split(' ')[0],
      last_name: fullName.split(' ')[1]
    };
  }

  closeDeletionPopup() {
    this.commentToDeleteId = null;
  }

  createComment() {
    if (!this.pendingCommentContent) {
      return;
    }
    this.create.emit(this.pendingCommentContent);
    this.pendingCommentContent = '';
  }

  startEditComment(commentId: string, content: any) {
    this.editCommentId = commentId;
    this.editCommentContent = content;
    this.scrollToElement('comments_tab')
  }

  scrollToElement(element: string): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest"
    });
  }

  cancelEdit() {
    this.editCommentId = null;
    this.editCommentContent = '';
  }

  editComment() {
    if (!this.editCommentId) {
      return;
    }
    this.edit.emit({
      commentId: this.editCommentId,
      commentContent: this.editCommentContent
    });

    this.editCommentId = null;
    this.editCommentContent = '';
  }

  startDeleteComment(commentId: any) {
    this.commentToDeleteId = commentId;
  }

  deleteComment() {
    if (!this.commentToDeleteId) return;
    this.delete.emit(this.commentToDeleteId);
    this.commentToDeleteId = null;
  }
}
